import { render, staticRenderFns } from "./VFatherProPatients.vue?vue&type=template&id=18a1cfa9"
import script from "./VFatherProPatients.vue?vue&type=script&lang=js"
export * from "./VFatherProPatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports